import { reduce, compact, trim, isString } from 'lodash';
import { retry } from 'async';
import moment from 'moment-timezone';
import callApi from '../../util/apiCaller';
import { UPDATE_ORGANIZATION } from '../Admin/AdminActions';
import { REQUEST_EMAIL_SIGNATURES } from '../../components/request-signature/actions';
// Export Constants

export const ADD_ALL_OPPORTUNITY_TYPES = 'ADD_ALL_OPPORTUNITY_TYPES';
export const ADD_OPPORTUNITY_TYPE_MAPPINGS = 'ADD_OPPORTUNITY_TYPE_MAPPINGS';
export const UPDATE_OPPORTUNITY_TYPE_MAPPINGS = 'UPDATE_OPPORTUNITY_TYPE_MAPPINGS';

export const ADD_ALL_OPPORTUNITY_STAGES = 'ADD_ALL_OPPORTUNITY_STAGES';
export const ADD_OPPORTUNITY_STAGE_MAPPINGS = 'ADD_OPPORTUNITY_STAGE_MAPPINGS';
export const UPDATE_OPPORTUNITY_STAGE_MAPPINGS = 'UPDATE_OPPORTUNITY_STAGE_MAPPINGS';

export const ADD_ALL_OWNERS = 'ADD_ALL_OWNERS';

export const ADD_ALL_SALE_REP_TYPE_MAPPINGS = 'ADD_ALL_SALE_REP_TYPE_MAPPINGS';
export const ADD_SALE_REP_TYPE_MAPPING = 'ADD_SALE_REP_TYPE_MAPPING';
export const UPDATE_SALE_REP_TYPE_MAPPING = 'UPDATE_SALE_REP_TYPE_MAPPING';
export const DELETE_SALE_REP_TYPE_MAPPING = 'DELETE_SALE_REP_TYPE_MAPPING';

export const ADD_ALL_SALE_REP_REGION_MAPPINGS = 'ADD_ALL_SALE_REP_REGION_MAPPINGS';
export const ADD_SALE_REP_REGION_MAPPING = 'ADD_SALE_REP_REGION_MAPPING';
export const UPDATE_SALE_REP_REGION_MAPPING = 'UPDATE_SALE_REP_REGION_MAPPING';
export const DELETE_SALE_REP_REGION_MAPPING = 'DELETE_SALE_REP_REGION_MAPPING';

export const ADD_ALL_PRODUCTS = 'ADD_ALL_PRODUCTS';
export const ADD_ALL_PRODUCT_MAPPINGS = 'ADD_ALL_PRODUCT_MAPPINGS';
export const UPDATE_PRODUCT_MAPPING = 'UPDATE_PRODUCT_MAPPING';

export const ADD_AMOUNT_FIELDS = 'ADD_AMOUNT_FIELDS';

export const VIEW_ORGANIZATION_USERS = 'VIEW_ORGANIZATION_USERS';
export const DELETE_ORGANIZATION_USER = 'DELETE_ORGANIZATION_USER';
export const ADD_ORGANIZATION_USER = 'ADD_ORGANIZATION_USER';
export const UPDATE_ORGANIZATION_USER = 'UPDATE_ORGANIZATION_USER';

export const ADD_PRODUCT_FIELDS = 'ADD_PRODUCT_FIELDS';
export const ADD_PRODUCT_SYNC_SETTINGS = 'ADD_PRODUCT_SYNC_SETTINGS';
export const ADD_DEAL_TYPE_FIELDS = 'ADD_DEAL_TYPE_FIELDS';
export const ADD_OUTCOME_TYPE_FIELDS = 'ADD_OUTCOME_TYPE_FIELDS';
export const ADD_INDUSTRY_FIELDS = 'ADD_INDUSTRY_FIELDS';
export const SYNC_ORGANIZATION = 'SYNC_ORGANIZATION';

export const ADD_ANNUAL_REVENUE_FIELDS = 'ADD_ANNUAL_REVENUE_FIELDS';
export const ADD_EMPLOYEE_COUNT_FIELDS = 'ADD_EMPLOYEE_COUNT_FIELDS';
export const ADD_FORECAST_CATEGORY_NAME_FIELDS = 'ADD_FORECAST_CATEGORY_NAME_FIELDS';

export const REQUEST_SYNC_ORGANIZATION = 'REQUEST_SYNC_ORGANIZATION';
export const END_REQUEST_SYNC_ORGANIZATION = 'END_REQUEST_SYNC_ORGANIZATION';
export const UPDATE_OWNER = 'UPDATE_OWNER';
export const ADD_CURRENCY_SYMBOLS = 'ADD_CURRENCY_SYMBOLS';

export const ADD_ALL_COMPETITORS = 'ADD_ALL_COMPETITORS';
export const ADD_ALL_ROLES = 'ADD_ALL_ROLES';
export const UPDATE_ROLE = 'UPDATE_ROLE';

export const ADD_ALL_STAGES = 'ADD_ALL_STAGES';

export const ADD_ALL_CONVERSION_STAGES = 'ADD_ALL_CONVERSION_STAGES';
export const UPDATE_CONVERSION_STAGE = 'UPDATE_CONVERSION_STAGE';

export const FETCH_TV_PRODUCT_MAPPINGS = 'FETCH_TV_PRODUCT_MAPPINGS';
export const UPDATE_TV_PRODUCT_MAPPINGS = 'UPDATE_TV_PRODUCT_MAPPINGS';

export const FETCH_TV_COLLECTOR_MAPPINGS = 'FETCH_TV_COLLECTOR_MAPPINGS';
export const UPDATE_TV_COLLECTOR_MAPPINGS = 'UPDATE_TV_COLLECTOR_MAPPINGS';
export const UPDATE_ORGANIZATION_USERS = 'UPDATE_ORGANIZATION_USERS';

export const FETCH_DISCOVERY_BOTS_SETTINGS = 'FETCH_DISCOVERY_BOTS_SETTINGS';

export const FETCH_FEEDBACK_REQUEST_REMINDER_EMAIL_SETTINGS = 'FETCH_FEEDBACK_REQUEST_REMINDER_EMAIL_SETTINGS';

export const ADD_DO_NOT_CONTACT_FIELDS = 'ADD_DO_NOT_CONTACT_FIELDS';

export const FETCH_FEEDBACK_REQUEST_SETTINGS = 'FETCH_FEEDBACK_REQUEST_SETTINGS';

export const ADD_ALL_ACCOUNT_INDUSTRIES = 'ADD_ALL_ACCOUNT_INDUSTRIES';

export const FETCH_DISCOVERY_BOT_LOGS = 'FETCH_DISCOVERY_BOT_LOGS';
export const FETCH_EMAIL_ALERTS = 'FETCH_EMAIL_ALERTS';
export const UPDATE_EMAIL_ALERT = 'UPDATE_EMAIL_ALERT';
export const FETCH_EMAIL_ALERT_SUBSCRIPTION = 'FETCH_EMAIL_ALERT_SUBSCRIPTION';


export const ADD_CLOSE_DATE_FIELDS = 'ADD_CLOSE_DATE_FIELDS';

export const FETCH_OPPORTUNITY_AUTOMATIONS = 'FETCH_OPPORTUNITY_AUTOMATIONS';
export const FETCH_ACCOUNT_AUTOMATIONS = 'FETCH_ACCOUNT_AUTOMATIONS';

export function startSyncingOrganization(id = null) {
  return {
    type: REQUEST_SYNC_ORGANIZATION,
    id,
  };
}
export function endSyncingOrganization(id = null) {
  return {
    type: END_REQUEST_SYNC_ORGANIZATION,
    id,
  };
}

// Opportunity Types
export function addAllOpportunityTypes(types) {
  return {
    type: ADD_ALL_OPPORTUNITY_TYPES,
    types,
  };
}
export function fetchAllOpportunityTypes() {
  return dispatch => callApi('deal-types', 'GET').then(res => dispatch(addAllOpportunityTypes(res.dealTypes)));
}
export function addOpportunityTypeMappings(mappings) {
  return {
    type: ADD_OPPORTUNITY_TYPE_MAPPINGS,
    mappings,
  };
}

export function fetchOpportunityTypeMappings() {
  return dispatch => callApi('setup/mappings/opportunity-types', 'GET').then(res => dispatch(addOpportunityTypeMappings(res.mappings)));
}

export function updateOpportunityTypeMappings(params) {
  return dispatch => callApi('setup/mappings/opportunity-types', 'PUT', params).then(res => dispatch(addOpportunityTypeMappings(res.mappings)));
}

// Opportunity Stages

export function addAllOpportunityStages(stages) {
  return {
    type: ADD_ALL_OPPORTUNITY_STAGES,
    stages,
  };
}

export function addOpportunityStageMappings(mappings) {
  return {
    type: ADD_OPPORTUNITY_STAGE_MAPPINGS,
    mappings,
  };
}

export function fetchOpportunityStageMappings() {
  return dispatch => callApi('setup/mappings/opportunity-stages', 'GET').then(res => dispatch(addOpportunityStageMappings(res.mappings)));
}

export function updateOpportunityStageMappings(params) {
  return dispatch => callApi('setup/mappings/opportunity-stages', 'PUT', params).then(res => dispatch(addOpportunityStageMappings(res.mappings)));
}

// Opportunity Sale Reps
export function addAllOwner(owners, ownerSearchableFields) {
  return {
    type: ADD_ALL_OWNERS,
    owners,
    ownerSearchableFields,
  };
}
export function fetchAllOwners(params = {}) {
  return dispatch => callApi('owners', 'GET', params).then(res => dispatch(addAllOwner(res.owners, res.searchableFields)));
}

/*
Rep Type mappings
*/
export function addAllSaleRepTypeMappings(mappings) {
  return {
    type: ADD_ALL_SALE_REP_TYPE_MAPPINGS,
    mappings,
  };
}
export function fetchAllSaleRepTypeMappings() {
  return dispatch => callApi('setup/mappings/rep-types', 'GET').then(res => dispatch(addAllSaleRepTypeMappings(res.mappings)));
}

export function requestAddSaleRepTypeMapping(params) {
  return dispatch => callApi('setup/mappings/rep-types', 'POST', params).then(res => dispatch(addAllSaleRepTypeMappings(res.mappings)));
}

export function updateSaleRepTypeMapping(mapping) {
  return {
    type: UPDATE_SALE_REP_TYPE_MAPPING,
    mapping,
  };
}
export function requestUpdateSaleRepTypeMapping(id, params) {
  return dispatch => callApi(`setup/mappings/rep-types/${id}`, 'PUT', params).then(res => dispatch(updateSaleRepTypeMapping(res.mapping)));
}

export function requestDeleteSaleRepTypeMapping(id) {
  return dispatch => callApi(`setup/mappings/rep-types/${id}`, 'DELETE').then(res => dispatch(addAllSaleRepTypeMappings(res.mappings)));
}

export function requestUnmapSaleRepTypeMapping(id) {
  return dispatch => callApi(`setup/mappings/rep-types/all/${id}`, 'DELETE').then(res => dispatch(addAllSaleRepTypeMappings(res.mappings)));
}

/*
Rep Region mappings
*/
export function addAllSaleRepRegionMappings(mappings) {
  return {
    type: ADD_ALL_SALE_REP_REGION_MAPPINGS,
    mappings,
  };
}
export function fetchAllSaleRepRegionMappings() {
  return dispatch => callApi('setup/mappings/rep-regions', 'GET').then(res => dispatch(addAllSaleRepRegionMappings(res.mappings)));
}

export function requestAddSaleRepRegionMapping(params) {
  return dispatch => callApi('setup/mappings/rep-regions', 'POST', params).then(res => dispatch(addAllSaleRepRegionMappings(res.mappings)));
}

export function updateSaleRepRegionMapping(mapping) {
  return {
    type: UPDATE_SALE_REP_REGION_MAPPING,
    mapping,
  };
}
export function requestUpdateSaleRepRegionMapping(id, params) {
  return dispatch => callApi(`setup/mappings/rep-regions/${id}`, 'PUT', params).then(res => dispatch(updateSaleRepRegionMapping(res.mapping)));
}

export function requestDeleteSaleRepRegionMapping(id) {
  return dispatch => callApi(`setup/mappings/rep-regions/${id}`, 'DELETE').then(res => dispatch(addAllSaleRepRegionMappings(res.mappings)));
}

export function requestUnmapSaleRepRegionMapping(id) {
  return dispatch => callApi(`setup/mappings/rep-regions/all/${id}`, 'DELETE').then(res => dispatch(addAllSaleRepRegionMappings(res.mappings)));
}

/*
Product mappings
*/

export function addAllProducts(products, productSearchableFields) {
  return {
    type: ADD_ALL_PRODUCTS,
    products,
    productSearchableFields,
  };
}
export function fetchAllProducts() {
  return dispatch => callApi('products', 'GET').then(res => dispatch(addAllProducts(res.products, res.searchableFields)));
}
export function requestDeleteProduct(id) {
  return dispatch => callApi(`products/${id}`, 'DELETE').then(() => dispatch(fetchAllProducts()));
}

export function addAllProductMappings(mappings) {
  return {
    type: ADD_ALL_PRODUCT_MAPPINGS,
    mappings,
  };
}
export function fetchAllProductMappings() {
  return dispatch => callApi('setup/mappings/products', 'GET').then(res => dispatch(addAllProductMappings(res.mappings)));
}

export function requestAddProductMapping(params) {
  return dispatch => callApi('setup/mappings/products', 'POST', params).then(res => dispatch(addAllProductMappings(res.mappings)));
}
export function updateProductMapping(mapping) {
  return {
    type: UPDATE_PRODUCT_MAPPING,
    mapping,
  };
}
export function requestUpdateProductMapping(id, params) {
  return dispatch => callApi(`setup/mappings/products/${id}`, 'PUT', params).then(res => dispatch(updateProductMapping(res.mapping)));
}

export function requestDeleteProductMapping(id) {
  return dispatch => callApi(`setup/mappings/products/${id}`, 'DELETE').then(res => dispatch(addAllProductMappings(res.mappings)));
}

export function requestUnmapProductMapping(id) {
  return dispatch => callApi(`setup/mappings/products/all/${id}`, 'DELETE').then(res => dispatch(addAllProductMappings(res.mappings)));
}

export function requestSyncDealTypes() {
  return (dispatch) => {
    dispatch(startSyncingOrganization());
    return callApi('organizations/sync/deal-types', 'GET').then(() => dispatch(fetchAllOpportunityTypes()));
  };
}

export function requestSyncStages() {
  return (dispatch) => {
    dispatch(startSyncingOrganization());
    return callApi('organizations/sync/stages', 'GET');
  };
}

export function requestRunAutomations() {
  return (dispatch) => {
    dispatch(startSyncingOrganization());
    return callApi('organizations/sync/feedback-request-automations', 'GET');
  };
}
export function requestRunAutomationsAndSendReminderEmails() {
  return (dispatch) => {
    dispatch(startSyncingOrganization());
    return callApi('organizations/sync/feedback-request-automations,feedback-request-reminder-emails', 'GET');
  };
}

export function syncActiveOwners() {
  return (dispatch) => {
    dispatch(startSyncingOrganization());
    return callApi('organizations/sync/active-owners', 'GET');
  };
}

export function addAllStages(stages) {
  return {
    type: ADD_ALL_STAGES,
    stages,
  };
}
export function fetchAllStages(params = {}) {
  return dispatch => callApi('stages', 'GET', params).then(res => dispatch(addAllStages(res.stages)));
}

export function fetchAllConversionStages(params = {}) {
  return dispatch => callApi('stages', 'GET', { is_closed: false, ...params }).then(({ stages }) => dispatch({
    type: ADD_ALL_CONVERSION_STAGES,
    stages,
  }));
}
export function updateConversionStage(id, params = {}) {
  return dispatch => callApi(`stages/${id}`, 'PUT', params).then(({ stage }) => dispatch({
    type: UPDATE_CONVERSION_STAGE,
    id,
    stage,
  }));
}
export function updateConversionStagePositions(positions = []) {
  return dispatch => callApi('stages', 'PUT', { positions }).then(({ stages }) => dispatch({
    type: ADD_ALL_CONVERSION_STAGES,
    stages,
  }));
}

export function addAllAccountIndustries(industries) {
  return {
    type: ADD_ALL_ACCOUNT_INDUSTRIES,
    industries,
  };
}
export function requestSyncAccountIndustries() {
  return (dispatch) => {
    dispatch(startSyncingOrganization());
    return callApi('organizations/sync/industries', 'GET');
  };
}

export function requestSyncOwners() {
  return (dispatch) => {
    dispatch(startSyncingOrganization());
    return callApi('organizations/sync/owners', 'GET').then(() => dispatch(fetchAllOwners()));
  };
}

export function requestSyncAccounts() {
  return (dispatch) => {
    dispatch(startSyncingOrganization());
    return callApi('organizations/sync/accounts', 'GET');
  };
}
export function requestSyncOpportunities() {
  return (dispatch) => {
    dispatch(startSyncingOrganization());
    return callApi('organizations/sync/opportunities', 'GET');
  };
}
export function requestSyncOpportunityAmounts() {
  return (dispatch) => {
    dispatch(startSyncingOrganization());
    return callApi('organizations/sync/amounts', 'GET');
  };
}
export function requestSyncProducts() {
  return (dispatch) => {
    dispatch(startSyncingOrganization());
    return callApi('organizations/sync/products', 'GET').then(() => dispatch(fetchAllProducts()));
  };
}

export function syncOrganization(organization) {
  return {
    type: SYNC_ORGANIZATION,
    organization,
  };
}

export function requestSyncOrganization(id = null) {
  return (dispatch) => {
    dispatch(startSyncingOrganization(id));
    const url = id ? `organizations/${id}/sync` : 'organizations/sync';
    /*
    return callApi(url, 'GET').then(res => {
      return dispatch(syncOrganization(res.organization));
    });
    */
    return callApi(url, 'GET'); // will be notified by socket
  };
}

export function addOrganizationUsers(users) {
  return {
    type: VIEW_ORGANIZATION_USERS,
    users,
  };
}
export function fetchOrganizationUsers(id, params = {}) {
  return (dispatch) => {
    const p = callApi(`organizations/${id}/users`, 'GET', params);
    p.then((res) => {
      dispatch(addOrganizationUsers(res.users));
      if (res.emailSignatures) {
        dispatch({
          type: REQUEST_EMAIL_SIGNATURES,
          signatures: reduce(res.emailSignatures, (items, signature, email) => {
            items.push({ email, status: 'loaded', signature });
            return items;
          }, []),
        })
      }
    });

    return p;
  };
}
export function paginateOrganizationUsers(id, params = {}) {
  return (dispatch) => {
    const p = callApi(`organizations/${id}/users`, 'GET', params);
    p.then((res) => {
      dispatch(addOrganizationUsers(res.users, params));
      return res.users;
    });
    return p;
  };
}

export function requestSyncUsers(id, params = {}) {
  return (dispatch) => {
    dispatch(startSyncingOrganization());
    return callApi('organizations/sync/users', 'GET').then(() => dispatch(fetchOrganizationUsers(id, params)));
  };
}

export function deleteOrganizationUser(id) {
  return {
    type: DELETE_ORGANIZATION_USER,
    id,
  };
}

export function requestDeleteOrganizationUser(orgId, userId) {
  return dispatch => callApi(`organizations/${orgId}/users/${userId}`, 'DELETE').then(() => dispatch(deleteOrganizationUser(userId)));
}
export function addOrganizationUser(user) {
  return {
    type: ADD_ORGANIZATION_USER,
    user,
  };
}
export function requestAddOrganizationUser(orgId, params = {}) {
  return dispatch => callApi(`organizations/${orgId}/users/`, 'POST', params).then(res => dispatch(addOrganizationUser(res.user)));
}

export function updateOrganizationUser(user) {
  return {
    type: UPDATE_ORGANIZATION_USER,
    user,
  };
}
export function requestUpdateOrganizationUser(orgId, userId, params = {}) {
  return dispatch => callApi(`organizations/${orgId}/users/${userId}`, 'PUT', params).then(res => dispatch(updateOrganizationUser(res.user)));
}

export function requestDisconnectOrganizationUser(orgId, userId) {
  return dispatch => callApi(`organizations/${orgId}/users/${userId}/disconnect`, 'PUT').then(res => dispatch(updateOrganizationUser(res.user)));
}

export function requestSyncOwnerProfile(orgId, userId) {
  return () => callApi(`organizations/${orgId}/users/${userId}/sync-owner`);
}


export function requestInviteOrganizationUser(orgId, userId) {
  return dispatch => callApi(`organizations/${orgId}/users/${userId}/invite`, 'POST', {}).then(res => dispatch(updateOrganizationUser(res.user)));
}

export function searchUsers(params = {}) {
  return () => callApi('users', 'GET', params);
}

export function addProductSyncSettings(settings) {
  return {
    type: ADD_PRODUCT_SYNC_SETTINGS,
    settings,
  };
}
export function requestFetchProductSyncSettings() {
  return dispatch => callApi('setup/product-fields', 'GET').then(res => dispatch(addProductSyncSettings(res)));
}
export function requestUpdateProductSyncSettings(params) {
  return dispatch => callApi('setup/product-fields', 'PUT', params).then(res => dispatch(addProductSyncSettings(res)));
}

export function requestFetchAllAmountFields() {
  return dispatch => callApi('setup/amount-fields', 'GET').then(res => dispatch({
    type: ADD_AMOUNT_FIELDS,
    fields: res.fields,
    stages: res.stages,
    possibleAmountFields: res.possible_fields,
  }));
}
export function requestUpdateAmountFields(params) {
  return dispatch => callApi('setup/amount-fields', 'PUT', params).then(({ fields }) => dispatch({
    type: ADD_AMOUNT_FIELDS,
    fields,
  }));
}
export function requestSyncAmountCustomFields() {
  return (dispatch) => {
    dispatch(startSyncingOrganization());
    return callApi('organizations/sync/meta-data', 'GET');
  };
}

export function addDealTypeFields(fields) {
  return {
    type: ADD_DEAL_TYPE_FIELDS,
    fields,
  };
}
export function requestFetchDealTypeFields() {
  return dispatch => callApi('setup/type-fields', 'GET').then(res => dispatch(addDealTypeFields(res.fields)));
}
export function requestUpdateDealTypeFields(params) {
  return dispatch => callApi('setup/type-fields', 'PUT', params).then(res => dispatch(addDealTypeFields(res.fields)));
}

export function addOutcomeTypeFields(fields) {
  return {
    type: ADD_OUTCOME_TYPE_FIELDS,
    fields,
  };
}
export function requestFetchOutcomeTypeFields() {
  return (dispatch) => {
    const p = callApi('setup/outcome-fields', 'GET');
    p.then(res => dispatch(addOutcomeTypeFields(res.fields)));
    return p;
  };
}
export function requestUpdateOutcomeTypeFields(params) {
  return (dispatch) => {
    const p = callApi('setup/outcome-fields', 'PUT', params);
    p.then(res => dispatch(addOutcomeTypeFields(res.fields)));
    return p;
  };
}

export function addIndustryFields(fields) {
  return {
    type: ADD_INDUSTRY_FIELDS,
    fields,
  };
}
export function requestFetchIndustryFields() {
  return dispatch => callApi('setup/industry-fields', 'GET').then(res => dispatch(addIndustryFields(res.fields)));
}
export function requestUpdateIndustryFields(params) {
  return dispatch => callApi('setup/industry-fields', 'PUT', params).then(res => dispatch(addIndustryFields(res.fields)));
}

export function addAnnualRevenueFields(fields) {
  return {
    type: ADD_ANNUAL_REVENUE_FIELDS,
    fields,
  };
}
export function requestFetchAnnualRevenueFields() {
  return dispatch => callApi('setup/annual-revenue-fields', 'GET').then(res => dispatch(addAnnualRevenueFields(res.fields)));
}
export function requestUpdateAnnualRevenueFields(params) {
  return dispatch => callApi('setup/annual-revenue-fields', 'PUT', params).then(res => dispatch(addAnnualRevenueFields(res.fields)));
}


export function requestFetchOwnerFields() {
  return dispatch => callApi('setup/owner-fields', 'GET');
}
export function requestUpdateOwnerFields(params) {
  return dispatch => callApi('setup/owner-fields', 'PUT', params);
}

export function requestFetchAccountOwnerFields() {
  return dispatch => callApi('setup/account-owner-fields', 'GET');
}
export function requestUpdateAccountOwnerFields(params) {
  return dispatch => callApi('setup/account-owner-fields', 'PUT', params);
}


export function addDoNotContactFields(fields) {
  return {
    type: ADD_DO_NOT_CONTACT_FIELDS,
    fields,
  };
}
export function requestFetchDoNotContactFields() {
  return dispatch => callApi('setup/custom-do-not-contact-fields', 'GET').then(res => dispatch(addDoNotContactFields(res.fields)));
}
export function requestUpdateDoNotContactFields(params) {
  return dispatch => callApi('setup/custom-do-not-contact-fields', 'PUT', params).then(res => dispatch(addDoNotContactFields(res.fields)));
}

export function addEmployeeCountFields(fields) {
  return {
    type: ADD_EMPLOYEE_COUNT_FIELDS,
    fields,
  };
}
export function requestFetchEmployeeCountFields() {
  return dispatch => callApi('setup/employee-count-fields', 'GET').then(res => dispatch(addEmployeeCountFields(res.fields)));
}
export function requestUpdateEmployeeCountFields(params) {
  return dispatch => callApi('setup/employee-count-fields', 'PUT', params).then(res => dispatch(addEmployeeCountFields(res.fields)));
}

export function addForecastCategoryNameFields(fields) {
  return {
    type: ADD_FORECAST_CATEGORY_NAME_FIELDS,
    fields,
  };
}
export function requestFetchForecastCategoryNameFields() {
  return dispatch => callApi('setup/forecast-category-name-fields', 'GET').then(res => dispatch(addForecastCategoryNameFields(res.fields)));
}
export function requestUpdateForecastCategoryNameFields(params) {
  return dispatch => callApi('setup/forecast-category-name-fields', 'PUT', params).then(res => dispatch(addForecastCategoryNameFields(res.fields)));
}

export function addProductFields(fields, useProductTable) {
  return {
    type: ADD_PRODUCT_FIELDS,
    fields,
    useProductTable,
  };
}

let fetchTVProductMappingPromise = null;
export function resetTVProductMappings() {
  return (dispatch) => {
    fetchTVProductMappingPromise = null;
    dispatch({
      type: FETCH_TV_PRODUCT_MAPPINGS,
      products: [],
      tvClients: {},
      useProductMappings: true,
      requireProducts: true,
      allowMultipleProducts: true,
      refs: {},
      dictionary: {},
    });
  };
}

export function requestFetchProductFields() {
  return (dispatch) => {
    const p = callApi('setup/product-fields', 'GET');
    p.then(res => dispatch(addProductFields(res.fields, res.use_product_table)));
    return p;
  };
}
export function requestUpdateProductFields(params) {
  return (disptach) => {
    const p = callApi('setup/product-fields', 'PUT', params);
    p.then(
      (res) => {
        resetTVProductMappings()(disptach);
        disptach(addProductFields(res.fields, res.use_product_table));
      },
    );
    return p;
  };
  // return dispatch => callApi('setup/product-fields', 'PUT', params).then(res => dispatch(addProductFields(res.fields, res.use_product_table)));
}

export function updateOwner(owner) {
  return {
    type: UPDATE_OWNER,
    owner,
  };
}

export function requestUpdateOwner(id, params = {}) {
  return dispatch => callApi(`owners/${id}`, 'PUT', params).then(res => dispatch(updateOwner(res.owner)));
}

export function updateRole(role) {
  return {
    type: UPDATE_ROLE,
    role,
  };
}
export function requestUpdateRole(id, params = {}) {
  return dispatch => callApi(`owners/roles/${id}`, 'PUT', params).then(res => dispatch(updateRole(res.role)));
}

export function addCurrencySymbols(currencies) {
  return {
    type: ADD_CURRENCY_SYMBOLS,
    currencies,
  };
}
export function requestFetchCurrencySymbols() {
  return dispatch => callApi('setup/currency-symbols', 'GET').then(res => dispatch(addCurrencySymbols(res.currencies)));
}

export function addAllCompetitors(competitors) {
  return {
    type: ADD_ALL_COMPETITORS,
    competitors,
  };
}
export function fetchAllCompetitors(params = {}) {
  return dispatch => callApi('competitors/hashed', 'GET', params).then(res => dispatch(addAllCompetitors(res.competitors)));
}

export function requestUpdateConmpetitor(id, params = {}) {
  return dispatch => callApi(`competitors/hashed/${id}`, 'PUT', params).then(res => dispatch(addAllCompetitors(res.competitors)));
}

export function requestSyncCompetitors() {
  return (dispatch) => {
    dispatch(startSyncingOrganization());
    return callApi('organizations/sync/competitors', 'GET').then(() => dispatch(fetchAllCompetitors()));
  };
}

export function addAllRoles(roles) {
  return {
    type: ADD_ALL_ROLES,
    roles,
  };
}
export function fetchAllRoles(params = {}) {
  return dispatch => callApi('owners/roles', 'GET', params).then(res => dispatch(addAllRoles(res.roles)));
}

export function requestSyncRoles() {
  return (dispatch) => {
    dispatch(startSyncingOrganization());
    return callApi('organizations/sync/roles', 'GET').then(() => dispatch(fetchAllRoles()));
  };
}

export function updateRepTypeSettings(params = {}) {
  return () => callApi('setup/rep-types', 'PUT', params);
}

export function updateRepRegionSettings(params = {}) {
  return () => callApi('setup/rep-regions', 'PUT', params);
}

export function fetchTVProductMappings() {
  return (dispatch) => {
    if (fetchTVProductMappingPromise === null) {
      fetchTVProductMappingPromise = callApi('truvoice/product-mappings', 'GET');
    }
    fetchTVProductMappingPromise
      .then(
        ({ tvClients, products, useProductMappings, requireProducts, allowMultipleProducts }) => {
          // fetchTVProductMappingPromise = null;
          return dispatch({
            type: FETCH_TV_PRODUCT_MAPPINGS,
            tvClients,
            products,
            useProductMappings,
            requireProducts,
            allowMultipleProducts,
          });
        },
        () => {},
      );
    return fetchTVProductMappingPromise;
  };
}

export function updateTVProductMappings(params) {
  return dispatch => callApi('truvoice/product-mappings', 'PUT', params)
    .then(
      (results) => {
        fetchTVProductMappingPromise = null;
        return dispatch({
          type: UPDATE_TV_PRODUCT_MAPPINGS,
          results,
          params,
        });
      },
      () => {},
    );
}

let fetchTVCollectorMappingPromise = null;
export function resetTVCollectorMappings() {
  return (dispatch) => {
    fetchTVCollectorMappingPromise = null;
    dispatch({
      type: FETCH_TV_COLLECTOR_MAPPINGS,
      collectors: {},
      clients: [],
    });
  };
}
export function fetchTVCollectorMappings() {
  return (dispatch) => {
    if (fetchTVCollectorMappingPromise === null) {
      fetchTVCollectorMappingPromise = new Promise((res, reject) => {
        retry(
          { times: 3 },
          (callback) => {
            callApi('truvoice/collector-mappings', 'GET')
              .then(
                (results) => {
                  callback(null, results);
                },
                (errors) => {
                  callback(errors);
                },
              );
          },
          (errors, results) => {
            if (errors) {
              reject(errors);
            } else {
              res(results);
            }
          },
        );
      });
    }
    fetchTVCollectorMappingPromise
      .then(
        (results) => {
          dispatch({
            type: FETCH_TV_COLLECTOR_MAPPINGS,
            clients: results.clients,
            collectors: results.collectors,
          });
        },
      );

    return fetchTVCollectorMappingPromise;
  };
}

export function fetchDiscoveryBotsSettings(id) {
  return dispatch => callApi(`organizations/${id}/discovery-bots`, 'GET')
    .then(
      (settings) => {
        dispatch({
          type: FETCH_DISCOVERY_BOTS_SETTINGS,
          settings,
        });
        return settings;
      },
      () => {},
    );
}

export function updateDiscoveryBotsSettings(id, params) {
  return (dispatch) => {
    const p = callApi(`organizations/${id}/discovery-bots`, 'PUT', params);
    p.then(
      (settings) => {
        dispatch({
          type: FETCH_DISCOVERY_BOTS_SETTINGS,
          settings,
        });
        return settings;
      },
      () => {},
    );
    return p;
  };
}

export function fetchDiscoveryBotLogs(params = {}) {
  return dispatch => callApi(`setup/discovery-bot-logs`, 'GET', params)
    .then(
      (logs) => {
        dispatch({
          type: FETCH_DISCOVERY_BOT_LOGS,
          logs,
        });
        return logs;
      },
      () => {},
    );
}

/* Target organization endpoint is commented out
export function fetchFeedbackRequestEmailSettings(id, emailType) {
  return dispatch => callApi(`organizations/${id}/feedback-request-emails/${emailType}`, 'GET')
    .then(
      (settings) => {
        dispatch({
          type: FETCH_FEEDBACK_REQUEST_REMINDER_EMAIL_SETTINGS,
          emailType,
          settings,
        });
        return settings;
      },
      () => {},
    );
}
*/

/* Target organization endpoint is commented out
export function updateFeedbackRequestEmailSettings(id, emailType, params) {
  return (dispatch) => {
    const p = callApi(`organizations/${id}/feedback-request-emails/${emailType}`, 'PUT', params);
    p.then(
      (settings) => {
        dispatch({
          type: FETCH_FEEDBACK_REQUEST_REMINDER_EMAIL_SETTINGS,
          emailType,
          settings,
        });
        return settings;
      },
      () => {
      },
    );
    return p;
  };
}
*/

export function fetchFeedbackRequestSettings(id) {
  return dispatch => callApi(`organizations/${id}/feedback-request-settings`, 'GET')
    .then(
      (settings) => {
        dispatch({
          type: FETCH_FEEDBACK_REQUEST_SETTINGS,
          settings,
        });
        return settings;
      },
      () => {},
    );
}

export function updateFeedbackRequestSettings(id, params) {
  return (dispatch) => {
    const p = callApi(`organizations/${id}/feedback-request-settings`, 'PUT', params);
    p.then(
      (settings) => {
        dispatch({
          type: FETCH_FEEDBACK_REQUEST_SETTINGS,
          settings,
        });
        return settings;
      },
      () => {
      },
    );
    return p;
  };
}

export function fetchEmailAlerts(orgId) {
  return dispatch => callApi(`organizations/${orgId}/email-alerts`, 'GET')
    .then(
      (emailAlerts) => {
        dispatch({
          type: FETCH_EMAIL_ALERTS,
          emailAlerts,
        });
        return emailAlerts;
      },
      () => {
        console.error('Failed to fetch email alerts');
      },
    );
}

export function updateEmailAlert(orgId, params) {
  return dispatch => callApi(`organizations/${orgId}/email-alert`, 'PUT', params)
    .then(
      (emailAlert) => {
        dispatch({
          type: UPDATE_EMAIL_ALERT,
          emailAlert,
        });
        return emailAlert;
      },
      () => {
        console.error('Failed to update email alert');
      },
    );
}

export function unsubscribeEmailAlert(key) {
  return callApi('public/unsubscribe/email-alert', 'POST', { key });
}

export function updateTVCollectorMappings(params) {
  return (dispatch) => {
    const p = callApi('truvoice/collector-mappings', 'PUT', params);
    p.then(
      (results) => {
        fetchTVCollectorMappingPromise = null;
        return dispatch({
          type: UPDATE_TV_COLLECTOR_MAPPINGS,
          results,
        });
      },
      () => {},
    );
    return p;
  };
}
export function updateOrganizationUserRoles(params) {
  return dispatch => callApi('organizations/my-organization/role-access-rules', 'PUT', params)
    .then(
      organization => dispatch({
        type: UPDATE_ORGANIZATION,
        organization,
      }),
      () => {},
    );
}

export function requestFetchAllCustomFields(objectType) {
  return () => callApi(`meta-data/${objectType}`, 'GET');
}

export function requestUpdateCustomFields(objectType, params) {
  return () => callApi(`meta-data/${objectType}`, 'PUT', params);
}

export function fetchInactiveStageMappings() {
  return () => callApi('stages/inactive-stages/mappings', 'GET');
}

export function updateInactiveStageMappings(stageId, params) {
  return () => callApi(`stages/inactive-stages/${stageId}/mapping`, 'PUT', params);
}
export function deleteInactiveStageMappings(stageId) {
  return () => callApi(`stages/inactive-stages/${stageId}/mapping`, 'DELETE');
}

export function requestInviteOrganizationUsers(orgId, ids) {
  return dispatch => callApi(`organizations/${orgId}/users/invite`, 'POST', { ids }).then((users) => {
    return dispatch({
      type: UPDATE_ORGANIZATION_USERS,
      users,
    });
  });
}

export function addCloseDateFields(fields) {
  return {
    type: ADD_CLOSE_DATE_FIELDS,
    fields,
  };
}
export function requestFetchCloseDateFields() {
  return dispatch => callApi('setup/close-date', 'GET').then(res => dispatch(addCloseDateFields(res.fields)));
}
export function requestUpdateCloseDateFields(params) {
  return dispatch => callApi('setup/close-date', 'PUT', params).then(res => dispatch(addCloseDateFields(res.fields)));
}

export function testDiscoveryBotStatus(orgId, params, automationId = null, debug = false) {
  const p = [];
  if (automationId) {
    p.push(`id=${automationId}`);
  }
  if (debug) {
    p.push('debug=true');
  }
  return () => callApi(`organizations/${orgId}/test-discovery-bots${p.length ? `?${p.join('&')}` : ''}`, 'POST', params);
}

export function getTestDiscoveryBotStatusResults(orgId, resultId) {
  return () => callApi(`organizations/${orgId}/test-discovery-bot-results/${resultId}`, 'GET');
}

export function fetchTvTagMappings(source = null) {
  if (source) {
    return () => callApi(`truvoice/${source}-tag-fields`, 'GET');  
  }
  return () => callApi('truvoice/tag-mappings', 'GET');
}

export function addTvTagMappings(source, params) {
  return () => callApi(`truvoice/${source}-tag-fields`, 'POST', params);  
}

export function deleteTvTagMappings(source, id) {
  return () => callApi(`truvoice/${source}-tag-fields/${id}`, 'DELETE');  
}


export function updateTvTagMappings(params) {
  return () => callApi('truvoice/tag-mappings', 'PUT', params);
}

export function pushTvTagMappings(params) {
  // return () => callApi('truvoice/push-tag-mappings', 'PUT', params);
  return () => callApi('truvoice/push-tag-fields', 'PUT', params);
}



export function pushTvTagMappingsStreaming(params, cb = () => {}) {
  return () => {
    let lastDataChunk = '';
    function decodeChunk(dataChunk, debug) {
      const dataChunks = compact(dataChunk.split(/(\]\s*\[)/).map((d) => {
        const s = trim(trim(d, '[]'));
        if (s.length > 0) {
          return s;
        }
        return null;
      })).join(',');
    
      try {
        const jsonData = JSON.parse(`[${dataChunks}]`);
        return jsonData;
      } catch (e) {
        return null;
      }
    }
  
    const onDownloadProgress = (progressEvent) => {
      // dataChunk contains the data that have been obtained so far (the whole data so far).. 
      // So here we do whatever we want with this partial data.. 
      const dataChunk = trim((progressEvent.currentTarget.response || '').substring(lastDataChunk.length));
  
  
  
      if (dataChunk.length > 0) {
        const jsonData = decodeChunk(dataChunk, progressEvent.currentTarget.response);
        if (jsonData) {
          lastDataChunk = progressEvent.currentTarget.response;
          cb(null, jsonData);
        }
      }
    };
    const response = callApi('truvoice/push-tag-fields', 'PUT', params, true, { responseType: 'stream', onDownloadProgress });
    response.then(
      (res) => {
        cb(null, isString(res) ? decodeChunk(res, true) || [] : res);
      },
      (error) => {
        cb(error);
      },
    );
    return response;
  };
}

export function pushTvSalesStages(params) {
  return () => callApi('truvoice/push-sales-stage', 'PUT', params);
}

export function feedbackHistoryRun(params) {
  const included = [
    'owners',
    'products',
    'repTypes',
    'repRegions',
    'stageHistories',
    'logHistories',
    'accountIndustries',
    'lineItems',
    'opportunityCompetitors',
    'accounts',
  ];

  return () => {
    const p = callApi(`setup/feedback-history-run?include=${included.join(',')}`, 'POST', params);
    return p;
  };
}


export function loadMetaData(params = {}) {
  return () => {
    const p = callApi('setup/meta', 'GET', params);
    return p;
  };
}
export function updateMetaData(name, params = {}) {
  return () => {
    const p = callApi(`setup/meta/${name}`, 'PUT', params);
    return p;
  };
}
export function updateMassMetaData(objects) {
  return () => {
    const p = callApi('setup/meta', 'PUT', { objects });
    return p;
  };
}

export function fetchAllFeedbackRequestAutomations(withDeleted = false) {
  return () => callApi('setup/feedback-request-automations', 'GET', withDeleted ? { withDeleted: true } : {})
    .then(
      (settings) => {
        return settings;
      },
      () => {},
    );
}

export function fetchFeedbackRequestAutomation(source, id) {
  return () => callApi(`setup/feedback-request-automations/${source}/${id}`, 'GET')
    .then(
      (settings) => {
        return settings;
      },
      () => {},
    );
}

export function orderFeedbackRequestAutomations(params, withDeleted = false) {
  return () => callApi(`setup/feedback-request-automations${withDeleted ? '?withDeleted=true' : ''}`, 'PUT', params)
    .then(
      (settings) => {
        return settings;
      },
      () => {},
    );
}

export function createFeedbackRequestAutomation(params) {
  return (dispatch) => {
    const p = callApi('setup/feedback-request-automations', 'POST', params)
    p.then(
      () => {
        resetTVCollectorMappings()(dispatch);
        fetchTVCollectorMappings()(dispatch);
      },
    );
    return p;
  };
}

export function cloneFeedbackRequestAutomation(id) {
  return () => callApi(`setup/feedback-request-automations/${id}/clone`, 'POST')
    .then(
      (settings) => {
        return settings;
      },
      () => {},
    );
}

export function switchSystemFeedbackRequestAutomation(id) {
  return () => callApi(`setup/feedback-request-automations/${id}/set-system`, 'POST')
    .then(
      (settings) => {
        return settings;
      },
      () => {},
    );
}

export function updateFeedbackRequestAutomation(id, params) {
  return (dispatch) => {
    const p = callApi(`setup/feedback-request-automations/${id}`, 'PUT', params);
    p.then(
      () => {
        resetTVCollectorMappings()(dispatch);
        fetchTVCollectorMappings()(dispatch);
      },
    );
    return p;
  };
}

export function deleteFeedbackRequestAutomation(id) {
  return (dispatch) => {
    const p = callApi(`setup/feedback-request-automations/${id}`, 'DELETE');
    p.then(
      () => {
        resetTVCollectorMappings()(dispatch);
        fetchTVCollectorMappings()(dispatch);
      },
    );
    return p;
  };
}

export function fetchAllAutomationEmails(type, withDeleted = false) {
  return () => callApi(`setup/${type}-automation-emails`, 'GET', withDeleted ? { withDeleted: true } : {})
    .then(
      (settings) => {
        return settings;
      },
      () => {},
    );
}

export function fetchAutomationEmail(type, source, id) {
  return () => callApi(`setup/${type}-automation-emails/${source}/${id}`, 'GET')
    .then(
      (settings) => {
        if (id === 'NEW') {
          settings.timezone = moment.tz.guess(true);
        }
        return settings;
      },
      () => {},
    );
}

export function orderAutomationEmails(type, params, withDeleted = false) {
  return () => callApi(`setup/${type}-automation-emails${withDeleted ? '?withDeleted=true' : ''}`, 'PUT', params)
    .then(
      (settings) => {
        return settings;
      },
      () => {},
    );
}

export function createAutomationEmail(type, params) {
  return () => {
    const p = callApi(`setup/${type}-automation-emails`, 'POST', params)
    return p;
  };
}

export function cloneAutomationEmail(type, id) {
  return () => callApi(`setup/${type}-automation-emails/${id}/clone`, 'POST')
    .then(
      (settings) => {
        return settings;
      },
      () => {},
    );
}

export function switchSystemAutomationEmail(type, id) {
  return () => callApi(`setup/${type}-automation-emails/${id}/set-system`, 'POST')
    .then(
      (settings) => {
        return settings;
      },
      () => {},
    );
}

export function updateAutomationEmail(type, id, params) {
  return () => {
    const p = callApi(`setup/${type}-automation-emails/${id}`, 'PUT', params);
    return p;
  };
}

export function deleteAutomationEmail(type, id) {
  return () => callApi(`setup/${type}-automation-emails/${id}`, 'DELETE')
    .then(
      (settings) => {
        return settings;
      },
      () => {},
    );
}

export function fetchTVFieldMappings(source = 'opportunity') {
  return () => callApi(`setup/${source}-field-mappings`, 'GET')
    .then(
      (settings) => {
        return settings;
      },
      () => {},
    );
}

export function loadTVFieldMapping(source, id) {
  return () => {
    const p = callApi(`setup/${source}-field-mappings/${id}`, 'GET');
    p.then(
      (settings) => {
        return settings;
      },
      () => {},
    );
    return p;
  }
}

export function createTVFieldMapping(source, params) {
  return () => {
    const p = callApi(`setup/${source}-field-mappings`, 'POST', params);
    p.then(
      (settings) => {
        return settings;
      },
      () => {},
    );
    return p;
  };
}

export function deleteTVFieldMapping(source, id) {
  return () => {
    const p = callApi(`setup/${source}-field-mappings/${id}`, 'DELETE');
    p.then(
      (settings) => {
        return settings;
      },
      () => {},
    );
    return p;
  }
}

export function updateTVFieldMapping(source, id, params) {
  return () => callApi(`setup/${source}-field-mappings/${id}`, 'PUT', params)
    .then(
      (settings) => {
        return settings;
      },
      () => {},
    );
}

export function getOpportunityQueryExplainations(orgId, opportunityId, settings, automationId) {
  const a = automationId ? `?automationId=${automationId}` : '';
  return () => callApi(`organizations/${orgId}/opportunities/${opportunityId}/query-explanations${a}`, 'POST', automationId ? {} : { settings });
}

export function getAccountOpportunities(orgId, accountId, settings, automationId) {
  const included = [
    'owners',
    'products',
    'repTypes',
    'repRegions',
    'stageHistories',
    'logHistories',
    'lineItems',
    'opportunityCompetitors',
    'accounts',
    'contactRoles',
  ];

  const a = automationId ? `&automationId=${automationId}` : '';

  return () => callApi(`organizations/${orgId}/accounts/${accountId}/query-explanations?include=${included.join(',')}${a}`, 'POST', automationId ? {} : { settings });
}

export function fetchAzureApps() {
  return () => callApi(`setup/azure-apps`, 'GET');
}

export function fetchServerTimeZone() {
  return () => callApi(`systems/timezone`, 'GET');
}

export function loadBenchmarks(type) {
  return () => callApi(`setup/benchmarks/${type}`, 'GET');
}

export function loadBenchmark(type, subType) {
  return () => callApi(`setup/benchmarks/${type}/${subType}`, 'GET');
}

export function updateBenchmark(type, subType, params) {
  return () => callApi(`setup/benchmarks/${type}/${subType}`, 'PUT', params);
}

export function requestSyncResource(resource) {
  return (dispatch) => {
    dispatch(startSyncingOrganization());
    return callApi(`organizations/sync/${resource}`, 'GET');
  };
}


export function fetchAllFeedbackLanguageSettings(source = 'opportunities') {
  return () => callApi(`setup/feedback-language-mappings/${source}`, 'GET')
    .then(
      (settings) => {
        return settings;
      },
      () => {},
    );
}

export function fetchFeedbackLanguageSettings(id) {
  return () => {
    const p = callApi(`setup/feedback-language-mappings/${id}`, 'GET');
    p.then(
      (settings) => {
        return settings;
      },
      () => {},
    );
    return p;
  }
}

export function orderFeedbackLanguageSettings(source, params) {
  return () => callApi(`setup/feedback-language-mappings/${source}`, 'PUT', params)
    .then(
      (settings) => {
        return settings;
      },
      () => {},
    );
}

export function createFeedbackLanguageSettings(params) {
  return () => {
    const p = callApi('setup/feedback-language-mappings', 'POST', params)
    p.then(
      () => {
      },
    );
    return p;
  };
}

export function updateFeedbackLanguageSettings(id, params) {
  return () => {
    const p = callApi(`setup/feedback-language-mappings/${id}`, 'PUT', params);
    p.then(
      () => {
      },
    );
    return p;
  };
}

export function deleteFeedbackLanguageSettings(id) {
  return () => {
    const p = callApi(`setup/feedback-language-mappings/${id}`, 'DELETE');
    p.then(
      () => {
      },
    );
    return p;
  };
}


export function getContactQueryExplainations(organizationId, isAccount, objectId, contactSource, contactId, params, automationId) {
  const a = automationId ? `?automationId=${automationId}` : '';
  return () => callApi(`organizations/${organizationId}/${isAccount ? 'accounts' : 'opportunities'}/${objectId}/${contactSource}/${contactId}/query-explanations${a}`, 'POST', params);
}




function getExcludeReasonApi(isAccount = false) {
  if (isAccount) {
    return 'setup/account-exclusion-reasons';
  }
  return 'setup/opportunity-exclusion-reasons';
}

export function fetchAllExclusionReasons(isAccount = false) {
  return () => callApi(getExcludeReasonApi(isAccount), 'GET')
    .then(
      (settings) => {
        return settings;
      },
      () => {},
    );
}

export function fetchExclusionReason(id, isAccount = false) {
  return () => callApi(`${getExcludeReasonApi(isAccount)}/${id}`, 'GET')
    .then(
      (settings) => {
        return settings;
      },
      () => {},
    );
}

export function reorderExclusionReasons(params, isAccount = false) {
  return () => callApi(getExcludeReasonApi(isAccount), 'PUT', params)
    .then(
      (settings) => {
        return settings;
      },
      () => {},
    );
}

export function createExclusionReason(params, isAccount = false) {
  return () => {
    const p = callApi(getExcludeReasonApi(isAccount), 'POST', params)
    return p;
  };
}

export function updateExclusionReason(id, params, isAccount = false) {
  return () => {
    const p = callApi(`${getExcludeReasonApi(isAccount)}/${id}`, 'PUT', params);
    return p;
  };
}

export function deleteExclusionReason(id, isAccount = false) {
  return () => {
    const p = callApi(`${getExcludeReasonApi(isAccount)}/${id}`, 'DELETE');
    return p;
  };
}





export function fetchOpportunityAutomationSettings(id) {
  return (dispatch) => {
    dispatch({
      type: FETCH_OPPORTUNITY_AUTOMATIONS,
      id,
      automations: [],
      error: null,
      loading: true,
      loaded: false,
    });
    const p = callApi(`organizations/${id}/opportunity-automations`, 'GET');
    p.then(
      (automations) => {
        dispatch({
          type: FETCH_OPPORTUNITY_AUTOMATIONS,
          id,
          automations,
          error: null,
          loading: false,
          loaded: true,
        });
      },
      (error) => {
        dispatch({
          type: FETCH_OPPORTUNITY_AUTOMATIONS,
          id,
          automations: [],
          error: error.data?.message || error,
          loading: false,
          loaded: false,
        });
      },
    );
    return p;
  };
}


export function resetOpportunityAutomationSettings() {
  return (dispatch) => {
    dispatch({
      type: FETCH_OPPORTUNITY_AUTOMATIONS,
      automations: [],
      error: null,
      loading: false,
      loaded: false,
    });
  };
}

export function fetchAccountAutomationSettings(id) {
  return (dispatch) => {
    dispatch({
      type: FETCH_ACCOUNT_AUTOMATIONS,
      id,
      automations: [],
      error: null,
      loading: true,
      loaded: false,
    });
    const p = callApi(`organizations/${id}/account-automations`, 'GET');
    p.then(
      (automations) => {
        dispatch({
          type: FETCH_ACCOUNT_AUTOMATIONS,
          id,
          automations,
          error: null,
          loading: false,
          loaded: true,
        });
      },
      (error) => {
        dispatch({
          type: FETCH_ACCOUNT_AUTOMATIONS,
          id,
          automations: [],
          error: error.data?.message || error,
          loading: false,
          loaded: false,
        });
      },
    );
    return p;
  };
}


export function resetAccountAutomationSettings() {
  return (dispatch) => {
    dispatch({
      type: FETCH_ACCOUNT_AUTOMATIONS,
      automations: [],
      error: null,
      loading: false,
      loaded: false,
    });
  };
}

export function sendSummaryEmail(automationId, id, isAccount = false) {
  return () => {
    return new Promise((resolve, reject) => {
      const p = callApi(`setup/summary-automation-emails/${isAccount ? 'accounts' : 'opportunities'}/${automationId}/send`, 'POST', { [`${isAccount ? 'account' : 'opportunity'}_ids`]: [id] });
      p.then(
        (results) => {
          const item = results[id];
          resolve(item);
        },
        (e) => {
          resolve({
            error: true,
            message: e.data?.message || e.message,
          });
        },
      )
    });
  };
}

export function sendReminderEmail(automationId, id, isAccount = false) {
  return () => {
    return new Promise((resolve, reject) => {
      const p = callApi(`setup/reminder-automation-emails/${isAccount ? 'accounts' : 'opportunities'}/${automationId}/send`, 'POST', { [`${isAccount ? 'account' : 'opportunity'}_ids`]: [id] });
      p.then(
        (results) => {
          const item = results[id];
          resolve(item);
        },
        (e) => {
          resolve({
            error: true,
            message: e.data?.message || e.message,
          });
        },
      )
    });
  };
}


export function requestUploadFileInChunks(data) {
  return (dispatch) => callApi('import/chunks', 'POST', data);
}

export function requestUploadFile(data, config = {}) {
  return (dispatch) => callApi('import', 'POST', data, true, config);
}

export function getAuditLogs(organization, key, subjectId) {
  return () => {
    return new Promise((resolve, reject) => {
      const p = callApi(`logs`, 'GET', { organizationId: organization.organization_id, key, subjectId: subjectId, withDetails: true });
      p.then(
        (results) => {
          resolve(results);
        },
        (e) => {
          reject(e);
        },
      );
    });
  };
}


export function sendTestEmail(params) {
  return () => {
    const p = new Promise((resolve, reject) => {
      callApi(`systems/emails`, 'POST', params).then(
        (results) => {
          resolve(results);
        },
        (e) => {
          reject(e);
        },
      );
    });
    return p;
  };
}


export function sendLoginLink(organizationId, userId) {
  return () => {
    const p = new Promise((resolve, reject) => {
      callApi(`organizations/${organizationId}/users/${userId}/send-login-link`, 'GET').then(
        (results) => {
          resolve(results);
        },
        (e) => {
          reject(e);
        },
      );
    });
    return p;
  };
}


export function getFeedbackAPIkey() {
  return () => {
    const p = new Promise((resolve, reject) => {
      callApi(`setup/feedback-request-automations/api-key`, 'GET').then(
        (results) => {
          resolve(results);
        },
        (e) => {
          reject(e);
        },
      );
    });
    return p;
  };
}


export function refreshFeedbackAPIkey(params) {
  return () => {
    const p = new Promise((resolve, reject) => {
      callApi(`setup/feedback-request-automations/api-key`, 'POST', params).then(
        (results) => {
          resolve(results);
        },
        (e) => {
          reject(e);
        },
      );
    });
    return p;
  };
}


export function requestFetchUserTypes() {
  return () => {
    const p = new Promise((resolve, reject) => {
      callApi(`setup/user-types`, 'GET').then(
        (results) => {
          resolve(results);
        },
        (e) => {
          reject(e);
        },
      );
    });
    return p;
  };
}


export function requestUpdateUserTypes(params) {
  return () => {
    const p = new Promise((resolve, reject) => {
      callApi(`setup/user-types`, 'PUT', params).then(
        (results) => {
          resolve(results);
        },
        (e) => {
          reject(e);
        },
      );
    });
    return p;
  };
}


export function fetchQuickSearchFields(source = 'opportunity') {
  return () => callApi(`setup/${source}-quick-search-fields`, 'GET');  
}

export function addQuickSearchFields(source, params) {
  return () => callApi(`setup/${source}-quick-search-fields`, 'POST', params);  
}

export function deleteQuickSearchFields(source, id) {
  return () => callApi(`setup/${source}-quick-search-fields/${encodeURIComponent(id)}`, 'DELETE');  
}